// test1766
(1766 && 0);
